import { connect } from 'react-redux'
import { CatalogComponent } from './CatalogComponent'
import {
    applySelectedAllergens,
    fetchCategoriesPageData,
    getProductsByCategoryId,
    resetCategoryWithProducts
} from 'shared/store/catalog'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import type { ECommerceMetadata, EventMetadata } from 'shared/store/metadata'
import { eCommerceMetadata, eventMetadata } from 'shared/store/metadata'

const mapStateToProps = (state: RootState) => {
    return {
        ...state.categoriesPageState
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchPageData: () => d(fetchCategoriesPageData()),
    applySelectedAllergens: (allergens: Array<string>) =>
        d(applySelectedAllergens(allergens)),
    getProductsByCategoryId: (categoryId: string) =>
        d(getProductsByCategoryId(categoryId)),
    resetCategoryWithProducts: () => d(resetCategoryWithProducts()),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    sendECommerceMeta: (meta: ECommerceMetadata) => d(eCommerceMetadata(meta))
})

const Catalog = connect(mapStateToProps, mapDispatchToProps)(CatalogComponent)

export { Catalog }
